module.exports = __webpack_public_path__ + "statics/img/4.66f9a6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/4.png
// module id = Ga2l
// module chunks = 1